module.exports = __webpack_public_path__ + "static/img/SFU老师_沈思远.4ec76ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_沈思远.png
// module id = 29/C
// module chunks = 0